import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 25vw;
	min-width: 400px;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;

	@media (max-width: 600px) {
		width: 100%;
		max-width: 100%;
		min-width: 100%;
	}
`;

export const banner = styled.div`
	position: relative;
	width: 99%;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	> img {
		width: 80px;
		height: 80px;
		border-radius: 5px;
		object-fit: contain;
		background-color: ${color.interface.lightGray3};
	}
`;

export const content = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	flex-direction: column;
	gap: 0.2rem;

	p,
	b {
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
	}
`;

export const actions = styled.div`
	position: absolute;
	top: 1rem;
	right: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 2.2rem;
	}
`;

export const noLink = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	padding: 1.5rem;

	> p {
		color: ${color.interface.lightGray};
		font-weight: 900;
		font-size: 1.5rem;
	}
`;

export const inputs = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1.5rem;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: flex-start;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: fit-content;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;

export const colorInfo = styled.div<{ $color: string }>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;

	p,
	b {
		font-size: 1.3rem;
		color: ${color.interface.darkgray};
	}

	> div {
		min-width: 10px;
		min-height: 10px;
		border-radius: 50%;
		background-color: ${(props) => props.$color};
	}
`;
